import { useEffect } from 'react';

/**
 * Sets the document title to the provided title when the component mounts, and resets it to the previous title when the component unmounts.
 * @param title The title to set for the document when the component is mounted.
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    return () => {
      if (previousTitle) {
        document.title = previousTitle;
      } else {
        document.title = '';
      }
    };
  }, [title]);
}
